import { Paging } from '@Core';
import { BaseHttpController } from '@Core/controller/BaseHttpController';
import { ParkingSpace } from '@EcamModel/model/ParkingSpace';
import { AxiosInstance } from 'axios';
import { IListParkingSpace, IParkingSpaceHttpController } from '../IParkingSpaceHttpController';

export class ParkingSpaceHttpController extends BaseHttpController<ParkingSpace> implements IParkingSpaceHttpController {
    constructor(serviceUrl: string, client: AxiosInstance) {
        super(serviceUrl, 'parking-space', client);
    }
    async list(props: IListParkingSpace): Promise<Paging<ParkingSpace>> {
        return await this.doPost({ path: 'filter', body: props }).then((res) => res.data);
    }
}
